import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "visible",
  "use": "visible-usage",
  "viewBox": "0 0 20 11",
  "content": "<symbol viewBox=\"0 0 20 11\" xmlns=\"http://www.w3.org/2000/svg\" id=\"visible\"><path d=\"M10 0c4.419 0 8.193 3.199 9.695 4.67.407.398.407 1.05 0 1.448-1.502 1.471-5.276 4.67-9.695 4.67-4.419 0-8.193-3.199-9.695-4.67a1.012 1.012 0 010-1.448C1.807 3.199 5.581 0 10 0zM6.154 5.394a3.846 3.846 0 107.692 0 3.846 3.846 0 00-7.692 0zm5.843 0a1.997 1.997 0 11-3.994 0 1.997 1.997 0 013.994 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol